export const RecomendationTableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: this.$t('Expediente'),
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (value) => {
                        return value.record;
                    }
                },
                {
                    title: this.$t('Evaluación'),
                    type: 'custom-html',
                    key: 'code',
                    modifier: (value) => {
                        return value;
                    }
                },
                {
                    title: this.$t('Estado'),
                    type: 'custom-html',
                    key: 'status',
                    modifier: (value) => {
                        if(value == 45){
                            return '<strong class="text-success"> Finalizado </strong>';
                        }else{
                            return '<strong class="text-danger"> En proceso </strong>';
                        }

                    }
                },


                {
                    title: this.$t('Informe'),
                    type: 'custom-html',
                    key: 'final_report_commission',
                    modifier: (value) => {
                        if(!value){
                            return 'No file'
                        }else{
                            return '<a  href="'+value.full_url+'" class="btn btn-success" target="_blank"><i data-feather="file" class="pr-2" /></a>'
                        }


                    }
                },


            ],

            actionObj: {
                title: this.$t('No acepta'),
                type: 'action'
            }
        }
    },
}